var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("h5", [
              _vm._v(
                "Información del usuario " +
                  _vm._s(_vm.modelValue.nombre_usuario)
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { readonly: "", id: "nombre" },
                        model: {
                          value: _vm.modelValue.nombre,
                          callback: function($$v) {
                            _vm.$set(_vm.modelValue, "nombre", $$v)
                          },
                          expression: "modelValue.nombre"
                        }
                      },
                      [
                        _vm._v(
                          "\n                                    Nombre\n                                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: { readonly: "", id: "email" },
                        model: {
                          value: _vm.modelValue.email,
                          callback: function($$v) {
                            _vm.$set(_vm.modelValue, "email", $$v)
                          },
                          expression: "modelValue.email"
                        }
                      },
                      [
                        _vm._v(
                          "\n                                    E-mail\n                                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-12" },
                [
                  _c("tabla-usuario-empresa", {
                    attrs: { empresasUsuario: _vm.modelValue.empresas },
                    model: {
                      value: _vm.roles,
                      callback: function($$v) {
                        _vm.roles = $$v
                      },
                      expression: "roles"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.guardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger btn--text",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancelar")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Cancelar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Usuario de empresa")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c70aef5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c70aef5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/UsuarioEmpresa.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3c70aef5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/UsuarioEmpresa.vue
// module chunks = 0